import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import $ from "jquery";
import { asArray } from "../../utils";

var OutputBinding = /*#__PURE__*/function () {
  function OutputBinding() {
    _classCallCheck(this, OutputBinding);

    _defineProperty(this, "name", void 0);
  }

  _createClass(OutputBinding, [{
    key: "find",
    value: // Returns a jQuery object or element array that contains the
    // descendants of scope that match this binding
    function find(scope) {
      throw "Not implemented";
      scope;
    }
  }, {
    key: "renderValue",
    value: function renderValue(el, data) {
      throw "Not implemented";
      el;
      data;
    }
  }, {
    key: "getId",
    value: function getId(el) {
      return el["data-input-id"] || el.id;
    }
  }, {
    key: "onValueChange",
    value: function onValueChange(el, data) {
      this.clearError(el);
      this.renderValue(el, data);
    }
  }, {
    key: "onValueError",
    value: function onValueError(el, err) {
      this.renderError(el, err);
    }
  }, {
    key: "renderError",
    value: function renderError(el, err) {
      this.clearError(el);

      if (err.message === "") {
        // not really error, but we just need to wait (e.g. action buttons)
        $(el).empty();
        return;
      }

      var errClass = "shiny-output-error";

      if (err.type !== null) {
        // use the classes of the error condition as CSS class names
        errClass = errClass + " " + $.map(asArray(err.type), function (type) {
          return errClass + "-" + type;
        }).join(" ");
      }

      $(el).addClass(errClass).text(err.message);
    }
  }, {
    key: "clearError",
    value: function clearError(el) {
      $(el).attr("class", function (i, c) {
        return c.replace(/(^|\s)shiny-output-error\S*/g, "");
      });
    }
  }, {
    key: "showProgress",
    value: function showProgress(el, show) {
      var recalcClass = "recalculating";
      if (show) $(el).addClass(recalcClass);else $(el).removeClass(recalcClass);
    }
  }]);

  return OutputBinding;
}();

export { OutputBinding };